/**
 * @generated SignedSource<<de327da05eff0c90f64224ee6aa4e5bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddNewPlayersHeaderNode$data = {
  readonly bookings?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly rounds: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly requirePlayerCounts?: boolean;
  readonly standardCapacity?: number;
  readonly " $fragmentType": "AddNewPlayersHeaderNode";
};
export type AddNewPlayersHeaderNode$key = {
  readonly " $data"?: AddNewPlayersHeaderNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddNewPlayersHeaderNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddNewPlayersHeaderNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePlayerCounts",
          "storageKey": null
        },
        {
          "alias": "standardCapacity",
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "bookings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoundConnection",
                      "kind": "LinkedField",
                      "name": "rounds",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RoundEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "522a634cfcf94f643cb7140f533946fb";

export default node;
